module.exports = __webpack_public_path__ + "img/OBCINA SKOFLJICA.55291545.png";